import merge from 'lodash/merge';
// date fns
import {
  fr as frFRAdapter,
  enUS as enUSAdapter,
  arSA as arSAAdapter,
  de as deDEAdapter,
  es as esESAdapter,
  ru as ruRUAdapter,
  // da as daDAAdapter,
  nl as nlNLAdapter,
  it as itITAdapter,
  tr as trTRAdapter,
  sv as svSEAdapter,
  pt as ptPTAdapter,
} from 'date-fns/locale';

// date pickers (MUI)
import {
  enUS as enUSDate,
  frFR as frFRDate,
  deDE as deDEDate,
  esES as esESDate,
  ruRU as ruRUDate,
  nlNL as nlNLDate,
  itIT as itITDate,
  trTR as trTRDate,
  svSE as svSEDate,
  ptBR as ptBRDate,
} from '@mui/x-date-pickers/locales';
// core (MUI)
import {
  enUS as enUSCore,
  frFR as frFRCore,
  arSA as arSACore,
  deDE as deDECore,
  esES as esESCore,
  ruRU as ruRUCore,
  // daDK as daDKCore,
  nlNL as nlNLCore,
  itIT as itITCore,
  trTR as trTRCore,
  svSE as svSECore,
  ptBR as ptBRCore,
} from '@mui/material/locale';
// data grid (MUI)
import {
  enUS as enUSDataGrid,
  frFR as frFRDataGrid,
  arSD as arSDDataGrid,
  deDE as deDEDataGrid,
  esES as esESDataGrid,
  ruRU as ruRUDataGrid,
  // daDK as daDKDataGrid,
  nlNL as nlNLDataGrid,
  itIT as itITDataGrid,
  trTR as trTRDataGrid,
  svSE as svSEDataGrid,
  ptBR as ptBRDataGrid,
} from '@mui/x-data-grid';

// PLEASE REMOVE `LOCAL STORAGE` WHEN YOU CHANGE SETTINGS.
// ----------------------------------------------------------------------

export const allLangs = [
  {
    label: 'English',
    value: 'en',
    systemValue: merge(enUSDate, enUSDataGrid, enUSCore),
    adapterLocale: enUSAdapter,
    icon: 'flagpack:gb-nir',
    numberFormat: {
      code: 'en-US',
      currency: 'USD',
    },
  },
  {
    label: 'French',
    value: 'fr',
    systemValue: merge(frFRDate, frFRDataGrid, frFRCore),
    adapterLocale: frFRAdapter,
    icon: 'flagpack:fr',
    numberFormat: {
      code: 'fr-Fr',
      currency: 'EUR',
    },
  },
  {
    label: 'German',
    value: 'de',
    systemValue: merge(deDEDate, deDEDataGrid, deDECore),
    adapterLocale: deDEAdapter,
    icon: 'flagpack:de',
    numberFormat: {
      code: 'de-De',
      currency: 'EUR',
    },
  },
  {
    label: 'Spanish',
    value: 'es',
    systemValue: merge(esESDate, esESDataGrid, esESCore),
    adapterLocale: esESAdapter,
    icon: 'flagpack:es',
    numberFormat: {
      code: 'es-ES',
      currency: 'EUR',
    },
  },
  {
    label: 'Italian',
    value: 'it',
    systemValue: merge(itITDate, itITDataGrid, itITCore),
    adapterLocale: itITAdapter,
    icon: 'flagpack:it',
    numberFormat: {
      code: 'it-IT',
      currency: 'EUR',
    },
  },
  {
    label: 'Russian',
    value: 'ru',
    systemValue: merge(ruRUDate, ruRUDataGrid, ruRUCore),
    adapterLocale: ruRUAdapter,
    icon: 'flagpack:ru',
    numberFormat: {
      code: 'ru-RU',
      currency: 'RUB',
    },
  },
  {
    label: 'Arabic',
    value: 'ar',
    systemValue: merge(arSDDataGrid, arSACore),
    adapterLocale: arSAAdapter,
    icon: 'flagpack:sa',
    numberFormat: {
      code: 'ar',
      currency: 'AED',
    },
  },
  {
    label: 'Dutch',
    value: 'nl',
    systemValue: merge(nlNLDate, nlNLDataGrid, nlNLCore),
    adapterLocale: nlNLAdapter,
    icon: 'flagpack:nl',
    numberFormat: {
      code: 'nl',
      currency: 'EUR',
    },
  },
  {
    label: 'Turkish',
    value: 'tr',
    systemValue: merge(trTRDate, trTRDataGrid, trTRCore),
    adapterLocale: trTRAdapter,
    icon: 'flagpack:tr',
    numberFormat: {
      code: 'tr',
      currency: 'EUR',
    },
  },
  {
    label: 'Swedish',
    value: 'sv',
    systemValue: merge(svSEDate, svSEDataGrid, svSECore),
    adapterLocale: svSEAdapter,
    icon: 'flagpack:se',
    numberFormat: {
      code: 'sv-SE',
      currency: 'SEK',
    },
  },
  {
    label: 'Portuguese',
    value: 'pt',
    // Assuming Portuguese system locale resources exist with similar naming conventions
    systemValue: merge(ptBRDate, ptBRDataGrid, ptBRCore),
    adapterLocale: ptPTAdapter,
    icon: 'flagpack:pt',
    numberFormat: {
      code: 'pt-PT',
      currency: 'EUR',
    },
  },
];

export const defaultLang = allLangs[0]; // English

// GET MORE COUNTRY FLAGS
// https://icon-sets.iconify.design/flagpack/
// https://www.dropbox.com/sh/nec1vwswr9lqbh9/AAB9ufC8iccxvtWi3rzZvndLa?dl=0
